import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=71076bca&scoped=true"
import script from "./channelDetail.vue?vue&type=script&lang=js"
export * from "./channelDetail.vue?vue&type=script&lang=js"
import style0 from "./channelDetail.vue?vue&type=style&index=0&id=71076bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71076bca",
  null
  
)

export default component.exports